export function ifSearchCards() {
  return Boolean(document.querySelector(".container-search-cards"));
}

export function ifSearchPopup() {
  return (
    Boolean(document.querySelector(".container-search-popup")) &&
    Boolean(document.querySelector("[data-popup-id=searchPopup]"))
  );
}

export function ifPetLanding() {
  return Boolean(document.querySelector(".freestyle-pet"));
}
